
import { AdvertiseFormValues } from "@/components/advertise/AdvertiseFormSchema";
import { sanitizeInput } from "@/utils/sanitization";

// The Supabase URL and anon key from environment variables
const SUPABASE_URL = "https://yeydokmtpjglqmpgragc.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlleWRva210cGpnbHFtcGdyYWdjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc1MTQzODUsImV4cCI6MjA1MzA5MDM4NX0.kwHOE8viTuhEJ5d47sSKyEs4BdCySd73kERVwMhGqrk";

export const submitAdvertiseRequest = async (data: AdvertiseFormValues) => {
  try {
    console.log("Submitting advertise request:", data);

    // Sanitize inputs to prevent XSS
    const sanitizedData = {
      businessName: sanitizeInput(data.businessName),
      contactName: sanitizeInput(data.contactName),
      email: sanitizeInput(data.email),
      phone: sanitizeInput(data.phone),
      message: data.message ? sanitizeInput(data.message) : "",
    };

    // Rate limiting check using sessionStorage 
    const lastSubmitTime = sessionStorage.getItem('lastAdvertiseSubmitTime');
    const now = Date.now();
    
    // Only apply rate limiting if a submission was made in the last 30 seconds
    if (lastSubmitTime && (now - parseInt(lastSubmitTime)) < 30 * 1000) { 
      console.log("Rate limiting applied, last submit was", (now - parseInt(lastSubmitTime))/1000, "seconds ago");
      throw new Error("Too many requests. Please try again in 30 seconds.");
    }
    
    // Set last submit time to session storage
    sessionStorage.setItem('lastAdvertiseSubmitTime', now.toString());

    // Using the Edge Function to process the request
    console.log("Calling handle-advertise-request function with data:", sanitizedData);

    const response = await fetch(
      `${SUPABASE_URL}/functions/v1/handle-advertise-request`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({
          ...sanitizedData,
          emailSubject: `New Advertising Inquiry from ${sanitizedData.businessName}`,
        })
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      console.error("Error response from handle-advertise-request function:", errorData || response.statusText);
      throw new Error(`Failed to save your request: ${errorData?.error || response.statusText}`);
    }

    const responseData = await response.json();
    console.log("Advertise request function response:", responseData);

    console.log("Advertise request submitted successfully");
    return true;
  } catch (error: any) {
    console.error("Advertise submission error:", error);
    throw error;
  }
};
